import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	clearIconLabel: {
		id: 'custom-sites-extensions.shared-components.link-picker.clear-icon-label',
		defaultMessage: 'Clear link selection',
		description: 'Label on hover for clear icon after link selection',
	},
	popupPlaceholderText: {
		id: 'custom-sites-extensions.shared-components.link-picker.popup-placeholder-text',
		defaultMessage: 'Add any link',
		description: 'Visible placeholder text to appear when no link selected in Popup button',
	},
});
